import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'icon-note',
  templateUrl: './icon-note.component.html',
  styleUrls: ['./icon-note.component.scss'],
})
export class IconNoteComponent  implements OnInit {
  @Input() size :number = 20;
  constructor() { }

  ngOnInit() {}

}
